import AccountBalance from "@mui/icons-material/AccountBalance";
import AccountTree from "@mui/icons-material/AccountTree";
import AddToQueue from "@mui/icons-material/AddToQueue";
import Assignment from "@mui/icons-material/Assignment";
import EngineeringIcon from "@mui/icons-material/Engineering";
import HikingIcon from "@mui/icons-material/Hiking";
import LocalOffer from "@mui/icons-material/LocalOffer";
import Mail from "@mui/icons-material/Mail";
import MonetizationOn from "@mui/icons-material/MonetizationOn";
import Notifications from "@mui/icons-material/Notifications";
import SurfingIcon from "@mui/icons-material/Surfing";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import WifiTetheringIcon from "@mui/icons-material/WifiTethering";
import Work from "@mui/icons-material/Work";
import { useTheme } from "@mui/material";
import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { useTenant } from "hooks/useTenant";

import { NavSection } from "../../components/LeftNavV2/LeftNavDrawerV2";

export function useStaffNavSectionsV2(): NavSection[] {
  const theme = useTheme();
  const { tenantId } = useTenant();
  const { featureFlags } = useFeatureFlags();

  return [
    {
      title: "Staff",
      textColor: theme.palette.warning.light,
      items: [
        {
          text: "Fulfillment",
          description: "Monitor report progress, assignments, and workflow outcomes.",
          path: "staff/fulfillment",
          Icon: HikingIcon,
          kind: "Standard",
          textColor: theme.palette.warning.light,
        },
        {
          text: "Requirements",
          kind: "Standard",
          path: "staff/requirements",
          Icon: Assignment,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "Organizations",
          description: "Manage organization setup, implementation details, and account context.",
          path: "staff/implementation",
          Icon: SurfingIcon,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "Agencies",
          description: "Maintain LEPC, fire department, and state agency records.",
          path: "staff/agencies",
          Icon: AccountBalance,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "Workflow Config",
          path: "staff/workflow-config",
          Icon: EngineeringIcon,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "Mail Room",
          description: "Create and track customer communications and delivery status.",
          path: "staff/mail-room",
          Icon: Mail,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "Notifications",
          path: "staff/notifications",
          Icon: Notifications,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "Payments",
          description: "Review payment records and reconcile report-level transactions.",
          path: "staff/payments",
          Icon: MonetizationOn,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "Jobs",
          path: "staff/jobs",
          Icon: Work,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "Pipelines",
          path: "staff/pipelines",
          Icon: AccountTree,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "Tags",
          path: "staff/tags",
          Icon: LocalOffer,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "Insights Demo Org Creator",
          path: "staff/insights-demo-org-creator",
          Icon: AddToQueue,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "RCRAInfo Credentials",
          path: "staff/rcra-info-credentials",
          Icon: VpnKeyIcon,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "STEERS Credentials",
          path: "staff/steers-credentials",
          Icon: VpnKeyIcon,
          textColor: theme.palette.warning.light,
        },
        ...(tenantId && featureFlags[FeatureFlagKey.Sse]
          ? [
              {
                kind: "Standard" as const,
                text: "SSE",
                description: "View live SSE diagnostic events for the current tenant.",
                path: `staff/sse/${tenantId}`,
                Icon: WifiTetheringIcon,
                textColor: theme.palette.warning.light,
              },
            ]
          : []),
      ],
    },
    {
      title: "Preview",
      textColor: theme.palette.warning.light,
      items: [
        {
          kind: "Standard",
          text: "Amazon Waste and Data Management",
          description:
            "Search and export Amazon waste generation records by site, profile, and shipment.",
          path: "staff/amazon-wadm",
          Icon: Assignment,
          textColor: theme.palette.warning.light,
        },
        {
          kind: "Standard",
          text: "Generator Status Changes",
          description: "Monitor potential generator status exceedances across facilities.",
          path: "staff/generator-status-changes",
          Icon: TrendingUpIcon,
          textColor: theme.palette.warning.light,
        },
      ],
    },
  ];
}
